import { render, staticRenderFns } from "./indexlist.vue?vue&type=template&id=58225db3&"
import script from "./indexlist.vue?vue&type=script&lang=js&"
export * from "./indexlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports